module.exports = __webpack_public_path__ + "media/images/lb/421-a6970604969b1e323297a15da97e8dcd.svg";